import { render, staticRenderFns } from "./number-stats.vue?vue&type=template&id=a18f4c30&scoped=true"
import script from "./number-stats.vue?vue&type=script&lang=js"
export * from "./number-stats.vue?vue&type=script&lang=js"
import style0 from "./number-stats.vue?vue&type=style&index=0&id=a18f4c30&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a18f4c30",
  null
  
)

export default component.exports